<template>
  <v-dialog
    v-model="internalValue"
    max-width="500px">
    <v-card>
      <v-card-title class="headline">
        {{ title }}
      </v-card-title>

      <v-card-text>
        <div class="mb-4">
          กรุณาพิมพ์ <strong>"confirm"</strong> เพื่อเปิดปุ่มยืนยัน
        </div>

        <v-text-field
          v-model="confirmText"
          label="พิมพ์ confirm"
          outlined
          dense
          autofocus
          :rules="[requiredRule]"
          clearable
          @keyup.enter="onEnter"
        />
        <div
          v-if="confirmText && !isConfirmed"
          class="caption red--text">
          ข้อความต้องตรงกับ <strong>confirm</strong>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :loading="clearLoading"
          text
          @click="onCancel">
          ยกเลิก
        </v-btn>
        <v-btn
          :loading="clearLoading"
          :disabled="!isConfirmed || clearLoading"
          color="primary"
          @click="onConfirm"
        >
          ยืนยัน
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    expectedText: {
      type: String,
      default: 'confirm'
    },
    title: {
      type: String,
      default: 'กรุณายืนยัน'
    },
    clearLoading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      internalValue: this.value,
      confirmText: ''
    }
  },
  computed: {
    isConfirmed () {
      if (!this.confirmText) return false
      return this.confirmText.trim().toLowerCase() === String(this.expectedText).trim().toLowerCase()
    },
    requiredRule () {
      return (v) => !!v || 'กรุณากรอกข้อความ'
    }
  },
  watch: {
    value (v) {
      this.internalValue = v
      if (v === true) {
        this.confirmText = ''
        this.$nextTick(() => {
          const el = this.$el.querySelector('input')
          if (el) el.focus()
        })
      }
    },
    internalValue (v) {
      this.$emit('input', v)
    }
  },
  methods: {
    onCancel () {
      this.internalValue = false
      this.confirmText = ''
      this.$emit('cancel')
    },
    onConfirm () {
      if (!this.isConfirmed) return
      this.$emit('confirm')
    },
    onEnter () {
      if (this.isConfirmed) this.onConfirm()
    }
  }
}
</script>
